// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__53CAn","name":"Header_name__WhlET","birthday":"Header_birthday__3Mq-x","skeleton":"Header_skeleton__Mdm2z"};